export var getParsedValue = function (key, value, parsers) {
    var parser = parsers === null || parsers === void 0 ? void 0 : parsers[key];
    return parser ? parser.parse(value) : value;
};
export var getStringValue = function (key, value, parsers, options) {
    var parser = parsers === null || parsers === void 0 ? void 0 : parsers[key];
    return parser ? parser.stringify(value, options) : value;
};
//# sourceMappingURL=parser.js.map